import createAttachmentInfo from './createAttachmentInfo';
import getAttachmentClass from './getAttachmentClass';
import AttachmentModel, { ReferenceAttachmentModel } from '../../store/schema/AttachmentModel';
import getDataProviderInfo from '../../utils/DataProviderInfo/getDataProviderInfo';
import getAttachmentThumbnailUrl from '../../utils/getAttachmentThumbnailUrl';
import getFullFileDownloadUrl from '../../utils/getFullFileDownloadUrl';
import getOpenUrlForReferenceAttachment from '../../utils/getOpenUrlForReferenceAttachment';
import isCloudyAttachment from '../../utils/isCloudyAttachment';
import shouldShowImageView from '../../utils/shouldShowImageView';
import { isFeatureEnabled } from 'owa-feature-flags';
import { AttachmentPolicyInfo, getAttachmentPolicyInfo } from 'owa-attachment-policy';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isStringNullOrWhiteSpace } from 'owa-strings';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import getStore from '../../store/store';

export default function initializeAttachment(
    attachment: AttachmentModel,
    permissionInfo: GetSharingInfoResponse,
    isReadOnly: boolean
): void {
    const isCloudy = isCloudyAttachment(attachment);
    const attachmentPolicyInfo: AttachmentPolicyInfo = getAttachmentPolicyInfo(
        attachment.model,
        true /* isWacPreviewSupportedOnPlatform */
    );

    const attachmentClass = getAttachmentClass(attachmentPolicyInfo, attachment.model);
    attachment.attachmentClass = attachmentClass;

    attachment.info = createAttachmentInfo(
        attachmentPolicyInfo,
        attachmentClass,
        attachment.model,
        isCloudy,
        isCloudy ? (<ReferenceAttachment>attachment.model).ProviderType : null,
        permissionInfo
    );

    // Initialize download URL
    if (attachment.info.allowDownload) {
        attachment.download.url = getFullFileDownloadUrl(
            attachment.id,
            attachment.model,
            true /* isReadOnly */,
            true /* addIsDownloadQueryParam */
        );
    }

    if (isCloudy) {
        (<ReferenceAttachmentModel>attachment).openUrl = getOpenUrlForReferenceAttachment(
            attachment.model,
            getUserConfiguration()
        );

        if (isFeatureEnabled('doc-attachment-sharingTips') && !isReadOnly) {
            const referenceAttachment = <ReferenceAttachment>attachment.model;
            const dataProviderInfo = getDataProviderInfo(referenceAttachment.ProviderType);
            if (
                dataProviderInfo &&
                dataProviderInfo.requiresFetchingSharingInformation &&
                !isStringNullOrWhiteSpace(referenceAttachment.AttachLongPathName)
            ) {
                (<ReferenceAttachmentModel>attachment).requiresFetchingSharingInformation = true;
            }
        }
    }

    // Initialize thumbnail url
    if (shouldShowImageView(attachment.model)) {
        const id = attachment.id.Id;
        getAttachmentThumbnailUrl(attachment.id, attachment.model, isCloudy).then(
            action('updateAttachmentThumbnailUrl')(function updateAttachmentThumbnailUrl(
                url: string
            ) {
                if (getStore().attachments.has(id)) {
                    getStore().attachments.get(id).thumbnailImage.url = url;
                }
            }),
            e => {
                trace.warn(e);
            }
        );
    }
}
